import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  useIonLoading,
} from "@ionic/react";
import React, { useState } from "react";
import axios from "axios";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { personCircle } from "ionicons/icons";
import { useHistory } from "react-router-dom";
import {
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonIcon,
  IonAlert,
} from "@ionic/react";
import { useAuth } from "../auth/authContext";
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import * as auth from "../auth/temp-auth";

import "./Page.css";
import styled from "styled-components";

const Login: React.FC = () => {
  const [present] = useIonLoading();
  const history = useHistory();
  //  let { logIn } = useAuth()!;
  const [userName, setUser] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [issuccess, setIssuccess] = useState<boolean>(false);
  const [iserror, setIserror] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const handleLogin = () => {
    if (!userName) {
      setMessage("Please enter user names");
      setIserror(true);
      return;
    }
   

    if (!password || password.length < 6) {
      setMessage("Please enter your password");
      setIserror(true);
      return;
    }

    const loginData = {
      username: userName,
      password: password,
    };
    present("Please wait...", 2000);
    const loginRequest = API.sendPostRequest(apiConstants.login, loginData);
    loginRequest
      .then(async (res) => {
        setMessage("Login Successfully!");
        await auth.setItem("auth", res.data.accessToken);
        localStorage.setItem("authToken", res.data.accessToken);
        localStorage.setItem("username", res.data.username);
        // await logIn();
        history.push("/dashboard");
      })
      .catch((error) => {
        setMessage("Auth failure! Please create an account");
        setIserror(true);
      });
  
  };

  return (
    <LoginPage>
      <IonPage>
        <IonContent fullscreen className="ion-padding ion-text-center">
          <IonGrid class="login_grid">
            <IonRow>
              <IonCol>
                <IonAlert
                  isOpen={iserror}
                  onDidDismiss={() => setIserror(false)}
                  cssClass="my-custom-class"
                  message={message}
                  buttons={["Dismiss"]}
                />
                <IonAlert
                  isOpen={issuccess}
                  onDidDismiss={() => setIssuccess(false)}
                  cssClass="my-custom-class"
                  message={message}
                  buttons={["Ok"]}
                />
              </IonCol>
            </IonRow>
            <div>
              <IonRow>
                <IonCol>
                  <img src="assets/logo.png" width="40%" />
                </IonCol>
              </IonRow>
              <IonRow style={{ marginTop: "20px" }}>
                <IonCol>
                  <IonItem>
                    <IonLabel position="floating" style={{color : "#006884"}}> User Name</IonLabel>
                    <IonInput
                      type="text"
                      value={userName}
                      onIonChange={(e) => setUser(e.detail.value!)}
                    ></IonInput>
                  </IonItem>
                </IonCol>
              </IonRow>

              <IonRow>
                <IonCol>
                  <IonItem>
                    <IonLabel position="floating" style={{color : "#006884"}}> Password</IonLabel>
                    <IonInput
                      type="password"
                      value={password}
                      onIonChange={(e) => setPassword(e.detail.value!)}
                    ></IonInput>
                  </IonItem>
                </IonCol>
              </IonRow>
              <IonRow class="button-margin">
                <IonCol>
                  <IonButton
                    expand="block"
                    onClick={handleLogin}
                    class="btncolor"
                  >
                    Login
                  </IonButton>
                </IonCol>
              </IonRow>
            </div>
          </IonGrid>
        </IonContent>
      </IonPage>
    </LoginPage>
  );
};

const LoginPage = styled(IonPage)`
  .button-margin {
    margin-top: 34px;
  }
  .login_grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    /* align-content: center; */
    align-items: center;
    height: 100%;
  }
`;
export default Login;
